import sendRequest from "@/libs/sendRequest";

export const promociones = {
    namespaced: true,

    state: {
        data: [],
        total_data: 0,
    },
    getters: {
        getItems: (state) => state.data,
        getTotal: (state) => state.total_data,
    },
    mutations: {
        setItems: (state, payload) => {
            state.data = payload; 
        },
        setTotalItems: (state, payload) => {
            state.total_data = payload; 
        },
    },
    actions: {
        list: async ({ commit, rootGetters }, { page = 1, rows = 10, search = '', order_by = 'Id', order_asc = true }) => {
            const custom_headers = rootGetters.getHeaders;

            try {
                const response = await sendRequest(`administrator/heishop/promociones/list?isDatatable=true&page=${page}&rows=${rows}&search=${search}&order_by=${order_by}&order_asc=${order_asc}`, 'GET', null, null, null, custom_headers);

                if (response.data) {
                    commit('setItems', response.data.list.result); 
                    commit('setTotalItems', response.data.list.total_rows);
                } else {
                    console.error('Error al cargar los datos:', response.errors);
                }
            } catch (error) {
                console.error('Error en la solicitud:', error);
            }
        },
        add: async ({ dispatch, rootGetters }) => {
            const custom_headers = rootGetters.getHeaders; 
            try {
                const response = await sendRequest(`administrator/heishop/promociones/add`, 'POST', null, null, null, custom_headers);

                if (response.success) {
                    await dispatch('list'); 
                    return response;
                } else {
                    throw new Error(response.errors ? response.errors[0].message : 'Error desconocido');
                }
            } catch (error) {
                console.error('Error al agregar el registro:', error);
                throw error; 
            }
        }
    },
};